import { Card, Space } from 'antd'
import { useFFEStore } from '../../store/ffeStore'
import { EditableTextArea } from '../Common/EditableTextArea'
import { useState } from 'react'

export const DocumentFooterDescription = () => {
  const footerContent = useFFEStore((state) => state.document.footerContent)
  const updatefooterContent = useFFEStore((state) => state.updatefooterContent)
  const [isEditing, setIsEditing] = useState(false)

  return (
    <Card className="mt-8">
      <Space direction="vertical" className="w-full">
        <EditableTextArea
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          value={footerContent}
          onChange={updatefooterContent}
          placeholder="Click to add footer description"
        />
      </Space>
    </Card>
  )
}
